import axios from 'axios'
import { getResponseData } from 'src/queries/network.utils'
import { getRequestConfig, RequestConfig } from 'src/queries/requestConfig'
import { StatisticRequest } from 'src/requests/statistics.request'

export interface StatisticsResponse {
  statistics: Array<{ value: number }>
}

/**
 * POST /statistics with an explicit list of statistic definitions.
 *
 * The backend computes each entry independently and returns values in request
 * order. Callers own the batching decision; the query layer sends one
 * definition per request so each stat has its own cache entry and can be
 * invalidated individually (see statisticsQueries.single).
 */
export const postStatistics = async (
  statistics: StatisticRequest[],
): Promise<StatisticsResponse> => {
  return getResponseData(
    axios.post<StatisticsResponse>(
      '/statistics',
      { statistics },
      getRequestConfig(RequestConfig.Default),
    ),
  )
}
